export default {
    methods: {
        getFormattedCurrency(data) {
            return 'RM ' + numeral(data).format('0,0.00');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/formatted-currency.js